export const sessionActions = {
  LOGIN: "SESSION/LOGIN",
  LOGOUT: "SESSION/LOGOUT",
  ME: "SESSION/ME",
  RESET: "SESSION/RESET",
};

export const requestActions = {
  REQUEST: "REQUEST/REQUEST",
  FAILED: "REQUEST/FAILED",
  SUCCESS: "REQUEST/SUCCESS",
  POP_MESSAGE: "REQUEST/POP_MESSAGE",
};

export const imageActions = {
  LIST: "IMAGE/LIST",
  CLEAR_CURRENT: "IMAGE/CLEAR_CURRENT",
  CURRENT: "IMAGE/CURRENT",
  CUD: "IMAGE/CUD",
};

export const fileActions = {
  LIST: "FILE/LIST",
  CLEAR_CURRENT: "FILE/CLEAR_CURRENT",
  CURRENT: "FILE/CURRENT",
  CUD: "FILE/CUD",
};

export const bannerActions = {
  LIST: "BANNER/LIST",
  CLEAR_CURRENT: "BANNER/CLEAR_CURRENT",
  CURRENT: "BANNER/CURRENT",
  CUD: "BANNER/CUD",
};

export const nationActions = {
  LIST: "NATION/LIST",
  CLEAR_CURRENT: "NATION/CLEAR_CURRENT",
  CURRENT: "NATION/CURRENT",
  CUD: "NATION/CUD",
};

export const videoActions = {
  LIST: "VIDEO/LIST",
  CLEAR_CURRENT: "VIDEO/CLEAR_CURRENT",
  CURRENT: "VIDEO/CURRENT",
  CUD: "VIDEO/CUD",
};

export const numberActions = {
  LIST: "NUMBER/LIST",
  CLEAR_CURRENT: "NUMBER/CLEAR_CURRENT",
  CURRENT: "NUMBER/CURRENT",
  CUD: "NUMBER/CUD",
};

export const activityActions = {
  LIST: "ACTIVITY/LIST",
  CLEAR_CURRENT: "ACTIVITY/CLEAR_CURRENT",
  CURRENT: "ACTIVITY/CURRENT",
  CUD: "ACTIVITY/CUD",
};

export const tagActions = {
  LIST: "TAG/LIST",
  CLEAR_CURRENT: "TAG/CLEAR_CURRENT",
  CURRENT: "TAG/CURRENT",
  CUD: "TAG/CUD",
};
